import { publicRequest } from '@/lib/axios/public-request';
import type { AvailableIntegration } from '@/types/integrations';
import type { ApiResponse } from '@/types/user';
import { integrationService } from '@/utils/api-service-controllers-route';
import { BASE_URL } from '@/utils/api-urls';

class IntegrationService {
  private static instance: IntegrationService;
  private readonly BASE_URL: string;

  private constructor() {
    this.BASE_URL = `${integrationService}/available-apps`;
  }

  public static getInstance(): IntegrationService {
    if (!IntegrationService.instance) {
      IntegrationService.instance = new IntegrationService();
    }
    return IntegrationService.instance;
  }

  async getAvailableIntegrationsPublic(): Promise<
    ApiResponse<AvailableIntegration[]>
  > {
    const response = await publicRequest(BASE_URL).get(
      `${this.BASE_URL}/public`
    );
    return response.data;
  }
}

export default IntegrationService.getInstance();
